<template>
  <form ref="root" class="search-bar" @submit="onSearch">
    <input
      ref="input"
      :value="modelValue"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
      @focus="$emit('focus', $event)">
    <TogglePill small :label="clearButtonLabel" type="button" @toggle="clearInput" />
  </form>
</template>

<script setup>
import { ref, watch } from 'vue';
import TogglePill from '@/components/filter/TogglePill.vue';

const props = defineProps({
  modelValue: { type: String },
  placeholder: { type: String },
  clearButtonLabel: { type: String },
});
const emit = defineEmits(['update:modelValue', 'search', 'focus', 'clear']);

const root = ref(null);
const input = ref(null);

defineExpose({
  root,
  focusInput,
  blurInput,
  clearInput,
});

// focus input when it's value changes dynamically
watch(() => props.modelValue, () => {
  focusInput();
});

function focusInput() {
  if (input.value) {
    input.value.focus();
  }
}

function blurInput() {
  if (input.value) {
    input.value.blur();
  }
}

function onSearch(e) {
  e.preventDefault();
  input.value.blur();
  emit('search', props.modelValue);
}

function clearInput() {
  emit('clear');
}
</script>
